/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import HomeLayout from 'apps/HomeLayout'
import AuthPage from 'apps/AuthPage'
import LeaveEmailForm from './apps/LeaveEmailForm'

const LeaveEmail: React.FC<{}> = () => (
  <HomeLayout>
    <AuthPage>
      <LeaveEmailForm />
    </AuthPage>
  </HomeLayout>
)

export default LeaveEmail
